// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nli[draggable=\"true\"] {\n&[data-v-64daf2fb] {\n  cursor: move;\n}\n&.hover[data-v-64daf2fb] {\n    opacity: 0.2;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
